import React from 'react';
import { AssignedProjects } from '../AssignedProjects';
import { AssignedTasks } from '../AssignedTasks';
import { Task } from '@models/task.model';

interface CrewAssignmentsProps {
  tasks: Task[];
  onManageTasks?: () => void;
  isReadOnly?: boolean;
}

export const CrewAssignments: React.FC<CrewAssignmentsProps> = ({
  tasks,
  onManageTasks,
  isReadOnly,
}) => {
  const projectSummaries = Array.from(
    (tasks ?? [])
      .reduce((acc, task: any) => {
        const projectId = task?.projectId;
        if (!projectId || acc.has(projectId)) return acc;
        acc.set(projectId, {
          name: task?.project?.name || 'This was removed',
          projectId,
          siteImage: task?.project?.siteImage,
        });
        return acc;
      }, new Map<string, { name: string; projectId: string; siteImage: string }>())
      .values(),
  );

  return (
    // Tasks take two thirds: the projects list is a handful of cards, the task
    // table now carries five columns and was unreadable at half width.
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pb-8 items-start">
      <AssignedProjects projects={projectSummaries} />
      <div className="lg:col-span-2 min-w-0">
        <AssignedTasks
          tasks={tasks || []}
          onManageTasks={onManageTasks}
          disabled={isReadOnly}
        />
      </div>
    </div>
  );
};

export default CrewAssignments;
